import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { LoginModal } from "./components/LoginModal";
import Calculator from "./pages/Calculator";
import AdminDashboard from "./pages/AdminDashboard";
import { api } from "./lib/api";

function App() {
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    api
      .get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setUser(data))
      .catch(() => localStorage.removeItem("access_token"));
  }, []);

  const handleLogout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("access_token");
    setUser(null);
  };

  return (
    <div className="App noise-bg flex min-h-screen flex-col">
      <Toaster position="top-center" richColors />
      <Header />
      <main className="relative z-10 flex-1">
        {user ? (
          <AdminDashboard user={user} onLogout={handleLogout} />
        ) : (
          <Calculator />
        )}
      </main>
      <footer className="border-t border-[#E2E8F0] bg-white/60 py-5">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-1 px-5 text-center">
          <p className="text-xs text-[#64748B]">
            © {new Date().getFullYear()} Shop C&F Online Agency · Compras y envíos internacionales
          </p>
          {!user && (
            <button
              onClick={() => setShowLogin(true)}
              data-testid="admin-access-link"
              className="text-[11px] text-[#94A3B8] underline-offset-2 transition-colors hover:text-[#1F2A5C] hover:underline"
            >
              Acceso administrativo
            </button>
          )}
        </div>
      </footer>
      <LoginModal
        open={showLogin}
        onClose={() => setShowLogin(false)}
        onSuccess={(u) => {
          setUser(u);
          setShowLogin(false);
        }}
      />
    </div>
  );
}

export default App;
